// removed by extract-text-webpack-plugin
module.exports = {"root":"Search--root--1A","input":"Search--input--1N","icon":"Search--icon--2u"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Search/styles.styl
// module id = 863
// module chunks = 0